if (!customElements.get('carousel-banner-second')) {
  class CarouselBannerSecond extends HTMLElement {
    constructor() {
      super();
      this.arrowsWrapper = this.querySelector('.carousel-banner-2__arrows-wrapper');
      this.toggleInitSlider = this.toggleInitSlider.bind(this);
      this.onResize = this.debounce(this.onResize.bind(this), 250);

      this.toggleInitSlider();
      window.addEventListener('resize', this.onResize);
    }

    connectedCallback() {
      this.toggleInitSlider();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.destroySlick();
    }

    debounce(func, wait) {
      let timeout;

      return function(...args) {
        const context = this;

        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    onResize() {
      this.destroySlick();
      this.toggleInitSlider();
    }

    toggleInitSlider() {
      const initHandler = $(this).find('.js--carousel-banner-2');
      const slickSettings = {
        slidesToShow: 3.78,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true,
        autoplay: false,
        prevArrow: '<button class="carousel-banner-2__arrow carousel-banner-2__arrow--prev"></button>',
        nextArrow: '<button class="carousel-banner-2__arrow carousel-banner-2__arrow--next"></button>',
        appendArrows: this.arrowsWrapper,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              slidesToShow: 3.65,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 751,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
        ],
      };

      if (!$(initHandler).hasClass('slick-initialized')) {
        $(initHandler).slick(slickSettings);
      }
    }

    destroySlick() {
      const initHandler = $(this).find('.js--carousel-banner-2');

      if ($(initHandler).hasClass('slick-initialized')) {
        $(initHandler).slick('unslick');
      }
    }
  }

  customElements.define('carousel-banner-second', CarouselBannerSecond);
}
